export var PROVIDER_SORT_BY_POPULARITY = 0;
export var PROVIDER_SORT_BY_NAME_ASC = 1;
export var PROVIDER_SORT_BY_NAME_DESC = 2;
export var PROVIDER_SORT_BY_NEWEST = 3;
export var PROVIDER_SORT_OPTIONS = [
    PROVIDER_SORT_BY_POPULARITY,
    PROVIDER_SORT_BY_NEWEST,
    PROVIDER_SORT_BY_NAME_ASC,
    PROVIDER_SORT_BY_NAME_DESC,
];



// WEBPACK FOOTER //
// ./src/constants/gamesSort.js